import { render, staticRenderFns } from "./Schoolclasses.vue?vue&type=template&id=d0d25ee4"
import script from "./Schoolclasses.vue?vue&type=script&lang=js"
export * from "./Schoolclasses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports